// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3obkN","header":"MessagesList_header__2R7fL","chat":"MessagesList_chat__2NGtV"};